import * as allTranslations from '../translations';
export const getSharedTranslations = (locale) => allTranslations[locale];
